import image1 from 'images/team/Image-1.jpg';
import image2 from 'images/team/Image-2.jpg';
import image3 from 'images/team/Image-3.jpg';
import image4 from 'images/team/Image-4.jpg';
import image5 from 'images/team/Image-5.jpg';
import image6 from 'images/team/Image-6.jpg';
import image7 from 'images/team/Image-7.jpg';
import image8 from 'images/team/Image-8.jpg';

export const data = [
    { img: image1, name: 'Guilherme Guerra', position: 'Co-Founder & Chief Executive Officer' },
    { img: image2, name: 'Francisco Bento', position: 'Chief Product Officer' },
    { img: image3, name: 'João Loff', position: 'Chief Technology Officer' },
    { img: image4, name: 'Richard Clark', position: 'Sales Manager' },
    { img: image5, name: 'Matilde Rasgado', position: 'Customer Success Manager' },
    { img: image6, name: 'David Martinez', position: 'Head of Research' },
    { img: image7, name: 'Jessica Turner', position: 'Product Manager' },
    { img: image8, name: 'Andrew Taylor', position: 'Logistics Manager' },
];
